import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';
import { getPosition, isDesktop } from '../utils/index.js';
import BackgroundVideo from '../components/BackgroundVideo';
import HandleControlVideoSwiper from '../components/HandleControlVideoSwiper.js';
import ADA from '../components/ADA';

export default class ModExpandingGallery {
  constructor(el) {
    this.$el = $(el);
    this.classes = {
      item: '.item-expanding-gallery',
      listWrapper: '.list-expanding-gallery .swiper-wrapper',
      firstSlider: 'first-slider',
      lastSlider: 'last-slider',
      swiperSlideActive: 'swiper-slide-active',
    };
    this.dom = {
      $list: this.$el.find('.list-expanding-gallery'),
      $item: this.$el.find('.list-expanding-gallery .item-expanding-gallery'),
      $fake: this.$el.find('.fake-expanding-gallery'),
      $videos: this.$el.find('.expanding-gallery-video'),
    };
    this.elementClasses = {
      itemGalleryExpand: '.item-expanding-gallery',
    };
    this.texts = {
      youtubeCom: 'youtube.com',
      youtuBe: 'youtu.be',
      vimeoCom: 'vimeo.com',
    };
    this.fakeHtml = '';
    this.playerVideos = [];
    this.positionFlag = 0;
    this.clsDoneAni = 'done-animation';
    this.handleControlVideoSwiper = new HandleControlVideoSwiper();
    this.adaInstance = new ADA();
    this.init();
  }

  init() {
    this.initExpanding();
    this.cloneBannerItemSlide();
    this.addCarousel();
    this.animation();
    this.controlVideos();
    this.addListeners();
  }

  addListeners() {
    window.scrollAgent.scrollEvent((args) => {
      this.winScrollTop = parseFloat(args.scroll.y.toFixed(2));
      if (this.positionFlag !== this.winScrollTop) {
        this.positionFlag = this.winScrollTop;
        this.handlePauseVideoWhenScrollOutModule();
        this.runAnimation();
      }
    });

    if (!isDesktop()) {
      this.$el.addClass(this.clsDoneAni);
    }
  }

  cloneBannerItemSlide() {
    if (this.dom.$item.length > 1) {
      this.dom.$item.last().addClass(this.classes.lastSlider).clone().prependTo(this.classes.listWrapper);
      this.dom.$item.eq(0).addClass(this.classes.firstSlider).clone().appendTo(this.classes.listWrapper);
      this.dom.$item = this.dom.$list.find(this.classes.item);
    }
  }

  controlVideos() {
    this.dom.$videos.each((_i, e) => {
      const player = new BackgroundVideo(e);
      player.init();
      this.playerVideos.push(player);
    });
  }

  addCarousel() {
    const swiper = new Swiper(this.dom.$list[0], {
      modules: [Navigation, A11y, Pagination],
      slidesPerView: 1,
      initialSlide: 1,
      speed: 500,
      navigation: {
        nextEl: this.$el.find('.swiper-button-next')[0],
        prevEl: this.$el.find('.swiper-button-prev')[0],
      },
      pagination: {
        el: this.$el.find('.swiper-pagination')[0],
        clickable: true,
      },
      on: {
        init: () => {
          this.changeNumberBullet();
        },
      },
    });

    const adaSlider = () => {
      $(this.elementClasses.itemGalleryExpand).find('*').attr('tabindex', '-1');
      $(`.${this.classes.swiperSlideActive}`).find('button, a, input').attr('tabindex', '0');
      $(`.${this.classes.swiperSlideActive}`).find('iframe').attr('tabindex', '-1');
    };
    swiper.on('init', () => {
      adaSlider();
    });
    swiper.on('slideChange', () => {
      this.handleSlideChange();
    });
    swiper.on('transitionEnd', (e) => {
      adaSlider();
      this.changeNumberBullet();
      this.adaInstance.removeAttrAriaDisabled(this.$el);

      setTimeout(() => {
        this.handleControlVideoSwiper.handleVideoSwiper(e);
      }, 500);
    });
    this.customControl(swiper);
    this.adaInstance.removeAttrAriaDisabled(this.$el);
  }

  changeNumberBullet () {
    const $bullet = this.dom.$list.find('.swiper-pagination-bullet');
    const ariaLabel = 'aria-label';
    $bullet.each((i, el) => {
      $(el).attr(ariaLabel, `Go To Slide ${i}`);
      if (i === 0) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
      if (i === $bullet.length - 1) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
    });
  }

  handleSlideChange() {
    const $iframe = $(this.elementClasses.itemGalleryExpand).find('iframe');
    if ($iframe.length) {
      $iframe.each((i, _el) => {
        const url = $($iframe[i]).attr('src');
        if (url) {

          if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
            $($iframe[i])[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
          if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
            $($iframe[i])[0].contentWindow.postMessage('{"method":"pause"}', '*');
          }
        } else {
          $($iframe[i]).parent()[0].sendNotification('doPause');
        }
      });
    }
  }

  customControl(swiper) {
    swiper.on('slideChange', (_e) => {
      setTimeout(() => {
        if (swiper.activeIndex === 0) {
          swiper.slideTo(swiper.slides.length - 2, 0, false);
        }
        if (swiper.activeIndex === swiper.slides.length - 1) {
          swiper.params.speed = 0;
          swiper.slideTo(1, 0, false);
          setTimeout(() => {
            swiper.params.speed = 500;
          }, 10);
        }
      }, 500);
    });
  }

  handlePauseVideoWhenScrollOutModule() {
    if (this.winScrollTop > getPosition(this.$el.get(0)).y + this.$el.innerHeight() - 200) {
      this.playerVideos.forEach((player) => {
        player.pauseVideo();
      });
    }
  }

  getSrc(el) {
    if ($(window).width() > 767) {
      return $(el).attr('data-image-dt');
    }
    return $(el).attr('data-image-mb');
  }

  getDataObject(el) {
    return $(el).find('img').attr('data-object');
  }

  returnHTML(src, object, i) {
    return `<div class="px-4 order-2">
    <div class="fake-expanding-img bg-white overflow-hidden relative w-150 h-165 md:w-[328px] md:h-[384px] lg:w-[457px] lg:h-[534px] xl:w-[368px] xl:h-[430px]  2xl:w-[411px] 2xl:h-240 1k6:w-[524px] 1k6:h-[612px] rounded-4">
    <img src="${src}" class="object-cover w-full h-full absolute top-0 left-0 ${object || ''}" alt="${src ? `image-${i}` : ''}">
    </div>
    </div>`;
  }

  initExpanding() {
    if (this.dom.$item.length === 2) {
      this.dom.$item.each((i, el) => {
        if (i === 1) {
          const src = this.getSrc(el);
          const object = this.getDataObject(el);
          this.fakeHtml += this.returnHTML(src, object, i);
        }
      });
    }
    this.dom.$item.each((i, el) => {
      if (i > this.dom.$item.length - 3) {
        const src = this.getSrc(el);
        const object = this.getDataObject(el);
        this.fakeHtml += this.returnHTML(src, object, i);
      }
    });
    if (this.dom.$item.length > 2) {
      this.dom.$item.each((i, el) => {
        if (i < 3) {
          const src = this.getSrc(el);
          const object = this.getDataObject(el);
          this.fakeHtml += this.returnHTML(src, object, i);
        }
      });
    }
  }

  callExpand() {
    const positionElm = getPosition(this.$el.get(0)).y + this.$el.innerHeight() - 100 < this.winScrollTop + $(window).innerHeight();
    if (positionElm && !this.$el.hasClass(this.clsDoneAni)) {
      this.checkExpand();
    }
  }

  runAnimation() {
    if (this.fakeHtml !== '') {
      if (this.dom.$item.length === 2){
        this.dom.$fake.addClass('two-fake-item');
        this.dom.$fake.prepend(this.fakeHtml);
      } else {
        this.dom.$fake.append(this.fakeHtml);
      }
      this.fakeHtml = '';
    }
    setTimeout(() => {
      this.callExpand();
    }, 500);
  }

  animation() {
    if (this.$el.hasClass('set-animation')) {
      this.runAnimation();
      return;
    }
    $(window).on('loadAnimation', (e) => {
      let { $element } = e.detail;
      if (!$element) {
        $element = $(e.detail[0]);
      }
      if ($element.is(this.$el)) {
        this.runAnimation();
      }
    });
  }

  expandMobile() {
    if (
      $(window).scrollTop() + $(window).innerHeight() + 250 >
      getPosition(this.$el.get(0)).y + this.$el.innerHeight() &&
      !this.$el.hasClass(this.clsDoneAni)
    ) {
      this.checkExpand();
    }
  }

  checkExpand() {
    const w = this.$el.innerWidth();
    const h = this.$el.innerHeight();
    $('.fake-expanding-img').css({ width: w, height: h });
    setTimeout(() => {
      this.$el.addClass(this.clsDoneAni);
      this.dom.$fake.remove();
    }, 650);
  }
}
